export default "__VITE_ASSET__CHE0foMT__"